var _path, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospitalIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.175C0 5.45093 5.45093 0 12.175 0H12.9127C19.6368 0 25.0877 5.45093 25.0877 12.175V12.9127C25.0877 19.6368 19.6368 25.0877 12.9127 25.0877H12.175C5.45093 25.0877 0 19.6368 0 12.9127V12.175Z",
    fill: "#EBEBEB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.03125,
    y: 7.03125,
    width: 11.022,
    height: 11.022,
    fill: "url(#pattern0_10229_28130)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_10229_28130",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10229_28130",
    transform: "scale(0.0138889)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10229_28130",
    width: 72,
    height: 72,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABxUlEQVR4nO2YQW7CMBBF3wqpnKAN5ZqFZcumPRD0CO0hYFmO0KJISK6QXKlCiWSDLcb2f9KsGDs/P3gyExBCCCGEEOKGTIEVsAOOgLswjn6PF+COisz5vMKUsfioxaRVBnP+4pkK2GU0aEsFHDMadNq7eFzmKJou4kbXwAx4BDYR607XKJZlxI0+/Fs3i1i3oEA6L7wPvMnvgT1+Atf2/lpdLc2eO4vDyOv6xf+WsqBnazKnGZq99dmxGqOLrEk3aTJXiQU6X4xDmVtvMncVGrS13uxtAgvr6Y32br3JdBnj4Avn0LFOWaSHogiD3JWv+SYMcmfHLaZRbMagjS/c80w1p3iD3A1CBiGDkEHIIGQQjRrUA0++hwn5BmQtP7tBi4HcRUH5yXAjMfQ9576g/GS4kRiaxmcF5SfDRfyllwXlJ8MFfDAPLaKW8rMb5AoPGYQMQgYhg5BBNGpQf8WsFEuzs1gszc1isVQ9i9WqB2uzjzU9WJt9rOnBJYpa9WBNkDU9WBNkTQ/WBFnTgzVB1vRgTZA1PVgTZE0P1gRZ04M1Qdb0sE8g5qtiPbwlEPRasR4mXtQlT27v104q1iOEEEIIIWiMX9AFCHeVdz8gAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalIcon);
export default __webpack_public_path__ + "static/media/hospitalIcon.2119f4a34c6cfb48854ace02f999f311.svg";
export { ForwardRef as ReactComponent };